export const GET_SWING_NOMS_BY_CONTRACT = '/api/SwingNominationsByContract';
export const GET_SWING_CONTRACTS_LITE = '/api/SwingContract/lite';
export const GET_SWING_NOMS_BY_CONTRACT_FOR_DATE =
  '/api/SwingNominationsByContract/ByDay';

export const MESSAGES = {
  DELETE_NOMS: 'Selected Nominations deleted successfully!',
  DELETE_NOMS_FAILED: 'Failed to delete selected Nominations!',
  UPDATE_NOMS: 'Nominations updated successfully!',
  UPDATE_NOMS_FAILED: 'Failed to update Nominations!',
};
